module.exports = __webpack_public_path__ + "static/heart_team-276cb99298b2a9de7b098c4eb370cdc7.png";